import types from '../types/segments'

const initialState = {
  segments: [],
  selectedSegment: null,
  openEditor: false,
  confirmDelete: false,
  loading: false,
  error: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_SEGMENTS_REQUEST:
    case types.CREATE_SEGMENT_REQUEST:
    case types.UPDATE_SEGMENT_REQUEST:
    case types.DELETE_SEGMENT_REQUEST:
      return { ...state, error: null, loading: true }

    case types.FETCH_SEGMENTS_ERROR:
    case types.CREATE_SEGMENT_ERROR:
    case types.UPDATE_SEGMENT_ERROR:
    case types.DELETE_SEGMENT_ERROR:
      return { ...state, error: action.payload, loading: false }

    case types.FETCH_SEGMENTS_SUCCESS:
      return { ...state, segments: action.payload, loading: false }

    case types.CREATE_SEGMENT_SUCCESS:
      return {
        ...state,
        segments: [...state.segments, action.payload],
        openEditor: false,
        selectedSegment: null,
        loading: false
      }

    case types.UPDATE_SEGMENT_SUCCESS:
      return {
        ...state,
        segments: state.segments.map(s =>
          s.segment_id === action.payload.segment_id ? action.payload : s
        ),
        openEditor: false,
        selectedSegment: null,
        loading: false
      }

    case types.DELETE_SEGMENT_SUCCESS:
      return {
        ...state,
        segments: state.segments.filter(s => s.segment_id !== action.payload),
        confirmDelete: false,
        selectedSegment: null,
        loading: false
      }

    case types.SET_SELECTED_SEGMENT:
      return { ...state, selectedSegment: action.payload }

    case types.SET_SEGMENT_OPEN:
      return {
        ...state,
        openEditor: action.payload.open,
        selectedSegment: action.payload.segment
      }

    case types.CONFIRM_SEGMENT_DELETE:
      return { ...state, confirmDelete: !!action.payload }

    default:
      return state
  }
}
